export default "__VITE_ASSET__txjcXHUqlc7E7r6yoMfYyQ__"